export const FacebookIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M9 5.50049V3.50049C9 2.94849 9.448 2.50049 10 2.50049H11V0.000488281H9C7.343 0.000488281 6 1.34349 6 3.00049V5.50049H4V8.00049H6V16.0005H9V8.00049H11L12 5.50049H9Z"
        fill="white"
      />
    </svg>
  );
};

export const LinkedinIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.5 1.75049C3.5 2.71699 2.7165 3.50049 1.75 3.50049C0.783502 3.50049 0 2.71699 0 1.75049C0 0.78399 0.783502 0.000488281 1.75 0.000488281C2.7165 0.000488281 3.5 0.78399 3.5 1.75049ZM0 5.00049H3.578V16.0005H0V5.00049ZM13.2998 5.12168C13.2954 5.12021 13.2909 5.11874 13.2864 5.11727C13.2616 5.10904 13.2367 5.10082 13.21 5.09349C13.162 5.08249 13.114 5.07349 13.065 5.06549C12.875 5.02749 12.667 5.00049 12.423 5.00049C10.337 5.00049 9.014 6.51749 8.578 7.10349V5.00049H5V16.0005H8.578V10.0005C8.578 10.0005 11.282 6.23449 12.423 9.00049V16.0005H16V8.57749C16 6.91549 14.861 5.53049 13.324 5.12949C13.3159 5.12692 13.3078 5.12431 13.2998 5.12168Z"
        fill="white"
      />
    </svg>
  );
};

export const Twitter = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M16 2.87298C15.405 3.13398 14.771 3.30698 14.11 3.39098C14.79 2.98498 15.309 2.34698 15.553 1.57798C14.919 1.95598 14.219 2.22298 13.473 2.37198C12.871 1.73098 12.013 1.33398 11.077 1.33398C9.261 1.33398 7.799 2.80798 7.799 4.61498C7.799 4.87498 7.821 5.12498 7.875 5.36298C5.148 5.22998 2.735 3.92298 1.114 1.93198C0.831 2.42298 0.665 2.98498 0.665 3.58998C0.665 4.72598 1.25 5.73298 2.122 6.31598C1.595 6.30598 1.078 6.15298 0.64 5.91198C0.64 5.92198 0.64 5.93498 0.64 5.94798C0.64 7.54198 1.777 8.86598 3.268 9.17098C3.001 9.24398 2.71 9.27898 2.408 9.27898C2.198 9.27898 1.986 9.26698 1.787 9.22298C2.212 10.522 3.418 11.477 4.852 11.508C3.736 12.381 2.319 12.907 0.785 12.907C0.516 12.907 0.258 12.895 0 12.862C1.453 13.799 3.175 14.334 5.032 14.334C11.068 14.334 14.368 9.33398 14.368 4.99998C14.368 4.85498 14.363 4.71498 14.356 4.57598C15.007 4.11398 15.554 3.53698 16 2.87298Z"
        fill="white"
      />
    </svg>
  );
};

export const YoutubeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.456 2.75899C14.415 2.81299 14.886 2.95499 15.32 3.72699C15.772 4.49799 16 5.82599 16 8.16499V8.16799V8.17299C16 10.501 15.772 11.839 15.321 12.602C14.887 13.374 14.416 13.514 13.457 13.579C12.498 13.634 10.089 13.667 8.002 13.667C5.911 13.667 3.501 13.634 2.543 13.578C1.586 13.513 1.115 13.373 0.677 12.601C0.23 11.838 0 10.5 0 8.17199V8.16999V8.16699V8.16399C0 5.82599 0.23 4.49799 0.677 3.72699C1.115 2.95399 1.587 2.81299 2.544 2.75799C3.501 2.69399 5.911 2.66699 8.002 2.66699C10.089 2.66699 12.498 2.69399 13.456 2.75899ZM11 8.16699L6 5.16699V11.167L11 8.16699Z"
        fill="white"
      />
    </svg>
  );
};

export const InstagramIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5 0.000488281H11C13.761 0.000488281 16 2.23949 16 5.00049V11.0005C16 13.7615 13.761 16.0005 11 16.0005H5C2.239 16.0005 0 13.7615 0 11.0005V5.00049C0 2.23949 2.239 0.000488281 5 0.000488281ZM11 14.5005C12.93 14.5005 14.5 12.9305 14.5 11.0005V5.00049C14.5 3.07049 12.93 1.50049 11 1.50049H5C3.07 1.50049 1.5 3.07049 1.5 5.00049V11.0005C1.5 12.9305 3.07 14.5005 5 14.5005H11ZM4 8.00049C4 5.79149 5.791 4.00049 8 4.00049C10.209 4.00049 12 5.79149 12 8.00049C12 10.2095 10.209 12.0005 8 12.0005C5.791 12.0005 4 10.2095 4 8.00049ZM5.5 8.00049C5.5 9.37849 6.622 10.5005 8 10.5005C9.378 10.5005 10.5 9.37849 10.5 8.00049C10.5 6.62149 9.378 5.50049 8 5.50049C6.622 5.50049 5.5 6.62149 5.5 8.00049ZM12.833 3.70049C12.833 3.99486 12.5944 4.23349 12.3 4.23349C12.0057 4.23349 11.767 3.99486 11.767 3.70049C11.767 3.40612 12.0057 3.16749 12.3 3.16749C12.5944 3.16749 12.833 3.40612 12.833 3.70049Z"
        fill="white"
      />
    </svg>
  );
};
